import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import chartUtils from '../../../util/chartUtils';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';
import ThroughputChart from './ThroughputChart';
import ExactThroughput from './ExactThroughput';
import ThroughputBreakdown from './ThroughputBreakdown';

import '../Throughput.scss';

class WallboardThroughputChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    const noData = !this.props.data.length || (_.every(this.props.data, d => d.data && _.every(d.data, item => item.y === 0 && (!item.details || item.details.length < 1))));

    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Throughput Run Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="trc" showLineChart showBreakdown options={{ lineChartTooltip: 'Throughput' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.lineChart && (chartUtils.hasValues(this.props.data) ? (
            <ExactThroughput data={this.props.data} dateFormat={this.props.dateFormat} />
          ) : (
            <CardPlaceholder title="Throughput" shape="line" loading={this.props.isLoading} />
          ))}
          {this.props.breakdown && (chartUtils.hasValues(this.props.data) ? (
            <ThroughputBreakdown id="throughput-breakdown" data={this.props.data} />
          ) : (
            <CardPlaceholder title="Throughput breakdown" shape={this.props.breakdownType === 'pie' ? 'pie' : 'columns'} loading={this.props.isLoading} />
          ))}
        </div>
        <div className="chart_row">
          <div className="diagram_details">
            <ThroughputChart id="Throughput" data={this.props.data} onPointClick={this.handlePointClick} />
            <NoData show={!chartUtils.hasValues(this.props.data)} loading={this.props.isLoading} />
          </div>
          <DetailsAccordion
            dateLabel="Date"
            valueLabel="Throughput"
            value2Label="Cycle time"
            id="details-accordion"
            data={this.state.selectedPoint}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    breakdown: state.filters.trc.breakdown,
    breakdownType: state.filters.trc.breakdownType,
    dateFormat: state.filters.dateFormat,
    lineChart: state.filters.trc.lineChart,
    data: state.throughput.data,
    isLoading: state.throughput.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardThroughputChart);
